export function setProveedores(state, proveedores) {
    state.proveedores = proveedores;
}

export function setTotalProveedores(state, total) {
    state.totalProveedores = total;
}

export function setProveedorSelec(state, proveedor) {
    state.proveedorSelec = proveedor;
}

export function actListProveedores(state, proveedor) {
    if (proveedor !== null) {
        const index = state.proveedores.findIndex(r => r.id === proveedor.id)
        if (index != -1) {
            Object.assign(state.proveedores[index], proveedor);
        }
    }
  
}

export function actDeleteListProveedores(state, id) {
    if (id != null) {
        const index = state.proveedores.findIndex(r => r.id === id)
        if (index != -1) {
            state.proveedores.splice(index, 1)
        }
    }
}

export function setMaestrasProveedores(state, maestras) {
    state.regimenes = maestras.regimenes;
    state.categoriasProveedor = maestras.categoriasProveedor;
    state.tiposHabitacion = maestras.tiposHabitacion;
    state.caracteristicasHabitacion = maestras.caracteristicasHabitacion;
    state.puntosProveedores = maestras.puntosProveedores;
}

export function setProveedoresDeServicios(state, proveedoresDeServicios) {
    state.proveedoresServiciosPaqueterias = proveedoresDeServicios.Paqueterias || [];
    state.proveedoresServiciosGuias = proveedoresDeServicios.Guias || [];
    console.log('Guias', state.proveedoresServiciosGuias);
    state.proveedoresServiciosBodegas = proveedoresDeServicios.Bodegas || [];
    state.proveedoresServiciosSeguros = proveedoresDeServicios.Seguros || [];
    state.proveedoresServiciosTransfers = proveedoresDeServicios.Transfers || [];
    state.proveedoresServiciosExcursiones = proveedoresDeServicios.Excursiones || [];
}
